if (!customElements.get('miguelito-size-chart')) {
  customElements.define('miguelito-size-chart', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.trigger = this.querySelector('.miguelito-size-chart-trigger');
      this.dialog = this.querySelector('dialog');
      this.select = this.dialog.querySelector('select');
      document.body.append(this.dialog);
      this.groups = this.readTables();
      this.active = 0;
      if (this.groups.length) {
        this.dialog.querySelector('.msc-html').hidden = false;
        const fallback = this.dialog.querySelector('.msc-fallback');
        if (fallback) fallback.hidden = true;
        this.createTabs();
      } else if (!this.dialog.querySelector('.msc-fallback')) this.trigger.hidden = true;
      this.trigger.addEventListener('click', () => this.open());
      this.dialog.querySelector('.msc-close').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('close', () => {
        if (this.isConnected) this.trigger.focus();
        else {
          const replacement = document.querySelector('miguelito-size-chart[data-section="' + CSS.escape(this.dataset.section) + '"]');
          this.dialog.remove();
          replacement?.querySelector('button')?.focus();
        }
      });
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const r = this.dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.dialog.close();
      });
      this.select.addEventListener('change', () => this.changeSize());
    }
    disconnectedCallback() { if (this.dialog && !this.dialog.open) this.dialog.remove(); }
    readTables() {
      const source = new DOMParser().parseFromString(this.querySelector('.msc-source').content.textContent, 'text/html');
      let heading = '';
      const groups = [];
      source.querySelectorAll('h1,h2,h3,h4,h5,h6,.mig-section-title,.mig-title,table').forEach(node => {
        if (node.tagName !== 'TABLE') { heading = node.textContent.trim(); return; }
        const rows = [...node.rows].map(row => [...row.cells].map(cell => cell.textContent.trim()));
        if (rows.length < 2) return;
        const name = node.caption?.textContent.trim() || heading || 'Medidas';
        const terms = (name + ' ' + rows[0].join(' ')).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
        if (!/medida|comprimento|torax|cintura|manga|circunferencia|peso|idade|busto|quadril|entreperna/.test(terms)) return;
        let label = name.replace(/^(?:tabela\s+de\s+)?medidas?\s+(?:do|da|dos|das|de)\s+/i, '').trim();
        if (/peso/.test(terms) && /idade/.test(terms)) label = 'Peso / idade';
        else if (/peso/.test(terms)) label = 'Peso de referência';
        else if (/idade/.test(terms)) label = 'Idade de referência';
        const previous = groups.find(g => g.label === label && JSON.stringify(g.headers) === JSON.stringify(rows[0]));
        if (previous) previous.rows.push(...rows.slice(1));
        else groups.push({label, title: name, headers: rows[0], rows: rows.slice(1)});
      });
      return groups;
    }
    inputs() {
      const root = document.getElementById('shopify-section-' + this.dataset.section) || document;
      return [...root.querySelectorAll('input[type="radio"]')].filter(input => input.name === this.dataset.optionName);
    }
    createTabs() {
      const tabs = this.dialog.querySelector('.msc-tabs');
      this.groups.forEach((group, i) => {
        const button = document.createElement('button');
        button.type = 'button'; button.role = 'tab'; button.id = this.dialog.id + '-tab-' + i;
        button.setAttribute('aria-controls', this.dialog.id + '-panel'); button.textContent = group.label;
        button.addEventListener('click', () => { this.active = i; this.render(); });
        button.addEventListener('keydown', event => {
          if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
          event.preventDefault();
          const count = this.groups.length;
          this.active = event.key === 'Home' ? 0 : event.key === 'End' ? count - 1 : (i + (event.key === 'ArrowRight' ? 1 : count - 1)) % count;
          this.render(); tabs.children[this.active].focus();
        });
        tabs.append(button);
      });
      tabs.hidden = this.groups.length < 2;
    }
    chooseGroup() {
      if (!this.groups.length || this.groups[this.active].rows.some(row => row[0] === this.select.value)) return;
      const found = this.groups.findIndex(g => !/peso|idade/i.test(g.label) && g.rows.some(row => row[0] === this.select.value));
      if (found >= 0) this.active = found;
    }
    open() {
      const checked = this.inputs().find(input => input.checked);
      if (checked) this.select.value = checked.value;
      this.chooseGroup(); this.render(); document.body.append(this.dialog); this.dialog.showModal();
    }
    changeSize() {
      const input = this.inputs().find(input => input.value === this.select.value);
      const status = this.dialog.querySelector('.msc-status');
      if (input && !input.disabled) {
        input.click();
        status.textContent = input.classList.contains('option-disabled') ? 'Esse tamanho está indisponível na combinação atual.' : '';
      } else status.textContent = 'Não foi possível selecionar esse tamanho no produto.';
      this.chooseGroup(); this.render();
    }
    render() {
      if (!this.groups.length) return;
      const group = this.groups[this.active]; const tabs = this.dialog.querySelectorAll('[role="tab"]');
      tabs.forEach((tab, i) => { tab.setAttribute('aria-selected', String(i === this.active)); tab.tabIndex = i === this.active ? 0 : -1; });
      this.dialog.querySelector('.msc-panel').setAttribute('aria-labelledby', tabs[this.active].id);
      this.dialog.querySelector('.msc-table-heading').textContent = group.label;
      this.dialog.querySelector('.msc-selected').textContent = 'Tamanho ' + this.select.value + ' selecionado';
      const table = document.createElement('table'); const caption = document.createElement('caption');
      caption.className = 'msc-visually-hidden'; caption.textContent = group.title; table.append(caption);
      const header = table.createTHead().insertRow();
      group.headers.forEach(value => { const cell = document.createElement('th'); cell.scope = 'col'; cell.textContent = value; header.append(cell); });
      const body = table.createTBody();
      group.rows.forEach(values => {
        const row = body.insertRow(); row.classList.toggle('msc-row-selected', values[0] === this.select.value);
        values.forEach((value, index) => { const cell = document.createElement(index === 0 ? 'th' : 'td'); if (index === 0) cell.scope = 'row'; cell.textContent = value; row.append(cell); });
      });
      this.dialog.querySelector('.msc-table-wrap').replaceChildren(table);
    }
  });
}
